import { Link, Navigate, useLocation } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { usePermissions } from "@/contexts/PermissionsContext";
import { canAccessRoute, findFirstAccessiblePath } from "@/lib/rbacRoutes";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function AccessDenied() {
  const location = useLocation();
  const from = location.state?.from;
  const { hasPermission, hasAnyAccess, loading } = usePermissions();

  if (!loading && !hasAnyAccess) {
    return <Navigate to="/pending-access" replace />;
  }

  const homePath = findFirstAccessiblePath(hasPermission);
  const canSettings = canAccessRoute("/settings", hasPermission);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full" data-testid="access-denied">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-cp-inset">
            <ShieldOff className="h-6 w-6 text-cp-mod" />
          </div>
          <CardTitle>Access denied</CardTitle>
          <CardDescription>
            You are signed in, but your access token does not include permission for this
            page{from ? ` (${from})` : ""}. Contact an administrator if you need access.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center gap-3 flex-wrap">
          {homePath ? (
            <Button asChild variant="default">
              <Link to={homePath}>
                {homePath === "/" ? "Go to Dashboard" : "Go to your home page"}
              </Link>
            </Button>
          ) : null}
          {canSettings ? (
            <Button asChild variant="outline">
              <Link to="/settings">Settings</Link>
            </Button>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}